// TOPO SÓ COM HAMBÚRGUER (#1473, cs2641 Due Imóveis).
//
// O topo central (`modelo_topo = 5`) monta sozinho um menu horizontal a partir do acervo:
// cada transação vira um item ("Venda" → "Comprar") e, se existir post publicado, entra o
// "Blog". Nenhum dos dois tem chave no painel para desligar — não são páginas de menu do CRM.
//
// A Due aprovou o modelo 5 ("o modelo escolhido está ok"), mas pediu o topo como as sócias
// desenharam no escopo: logo centralizada, NENHUM link de texto e o ícone de 3 listras à
// direita abrindo a barra lateral — o mesmo padrão do site de referência que enviaram.
// 15/09 o Daniel repetiu o pedido ("remova Comprar e Blog; o menu na direita, não na esquerda"):
// não é opção do Builder (rascunho = versão publicada), por isso fica aqui no código.
//
// Allowlist e não regra geral: nos demais tenants em modelo_topo 5 esse menu é o único
// caminho para as listagens no desktop (lá o hambúrguer só aparece até 900px).
export const TOPO_SEM_MENU_DE_TEXTO = new Set<number>([2641]);

/** true = topo sem menu de texto e com hambúrguer visível em qualquer largura. */
export function ehTopoSoHamburguer(site: any): boolean {
  return TOPO_SEM_MENU_DE_TEXTO.has(Number(site?.id));
}
